import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { PropertyPanelComponent } from "./propertyPanelComponent";
import { PropertyControlComponent } from "./propertyControlComponent";
import { ImageModule, DropdownModule, TextBoxModule, GridviewModule, FloatingModule, DatepickerModule, CheckboxModule } from "../../../../shared/components";

export * from "./propertyPanelComponent";
export * from "./propertyControlComponent";

@NgModule({
  imports: [
    CommonModule,
    DropdownModule,
    TextBoxModule,
    CheckboxModule,
    FloatingModule,
    ImageModule,
    GridviewModule,
    DatepickerModule
  ],
  declarations: [
    PropertyPanelComponent,
    PropertyControlComponent    
  ],
  exports: [
    PropertyPanelComponent,
    PropertyControlComponent
  ]
})
export class PropertyPanelModule {

}